// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"9":"Contact","594":"about","828":"Team","940":"Service"}[chunkId] + "." + {"9":"2d1cc6de","594":"590b8d17","828":"7c9a3253","940":"af1358ed"}[chunkId] + ".js";
};